import React from 'react';
import { RiDeleteBin7Fill } from 'react-icons/ri'
import { useContext } from 'react';
import { RouterContext } from '../../../../contexts/routerContext';
import { WidgetContext } from '../../../../contexts/widgetContext';

import { MdCall } from 'react-icons/md';

import {
    BackgroundShadow,
    Container,
    HeaderContainer,
    Content,
    ItemContainer,
    PhoneNumber,
    ItemTitle,
} from './styles';

function SelectNumberToCall({ open, setOpenModalToCall, call }) {
    const { routerParams: contact, setRouterParams, setRouter } = useContext(RouterContext);
    const { callInProgress, setCallInProgress, interationSIP } = useContext(WidgetContext);

    const handleCall = (number) => {
        if (callInProgress.status === 'Progress') {
            interationSIP.transfer(number).then(() => {
                setCallInProgress({
                    type: "",
                    number: "",
                    time: "",
                    status: "",
                    answered_call: "",
                })
                setRouter('home')
            });
        } else {
            call(number)
        }

    }

    return (
        <BackgroundShadow open={open} onClick={() => setOpenModalToCall(false)}>
            <Container>
                <HeaderContainer>
                    <span>
                        Escolha o número para chamada
                    </span>
                </HeaderContainer>
                <Content>
                    <Item phone={contact?.phone_number} title='Telefone' action={() => handleCall(contact?.phone_number)} />
                    <Item phone={contact?.extension} title='Ramal' action={() => handleCall(contact?.extension)} />
                </Content>
            </Container>
        </BackgroundShadow>

    );
}

const Item = ({ phone, title, action }) => {
    return (
        <ItemContainer>
            <MdCall size={30} color='#00587A' style={{ marginRight: '10px' }} cursor='pointer' onClick={action} />
            <div>
                <PhoneNumber>{phone}</PhoneNumber>
                <ItemTitle>{title}</ItemTitle>
            </div>
        </ItemContainer>
    )
}

export default SelectNumberToCall;